import { bearerValue as c } from "@waitroom/http-client";
import { config as i } from "./config.es.js";
const n = async (t) => typeof t == "function" ? await t() : await t, l = async () => {
  const t = await n(i.getAuthToken);
  return {
    Authorization: t ? c(t) : void 0
  };
}, g = async () => {
  const [t, a] = await Promise.allSettled([
    n(i.getFingerPrint),
    n(i.getClientDetails)
  ]);
  return {
    "X-Fingerprint": t.status === "fulfilled" ? t.value : "",
    "X-Client-Info": JSON.stringify(a.status === "fulfilled" ? a.value : {}),
    "Accept-Language": "en"
    // TODO: This should be updated to pick the app's language
  };
}, f = (t, a) => `${t || i.baseURL}/${a || i.version}`, m = async (t, a) => ({
  ...await g(),
  // add auth header if non provided
  ...t && !(a != null && a.Authorization) ? await l() : {},
  ...a
}), e = (t) => async (a, { version: s, baseURL: o, headers: r, ...u } = {}) => ({
  url: a,
  baseURL: f(o, s),
  headers: await m(t, r),
  ...u
}), d = e(!1), w = e(!0);
export {
  d as buildApiParams,
  w as buildApiParamsWithAuth,
  m as buildHeaders,
  l as getAuthHeader,
  f as getBaseURL
};
